// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3cb109cc","732":"39828f93","977":"e65e7029"}[chunkId] + ".chunk.js";
};